gx-designer-view {
    display: block;    

    .root {
        
        z-index: 9999;

        position: fixed;

        &.selected {
            outline-width: 2px;
            outline-style: solid;
            outline-color: var(--color-border-item-selected);
            outline-offset: -1px;
        }

        &.highlight {
            animation-name: gx-designer-view-highlight;
            animation-duration: 0.25s;
            animation-iteration-count: 2;
            animation-delay: 0.1;
        }

        &.smooth {
            transition: top 0.1s, left 0.1s, width 0.1s, height 0.1s;
        }

        .surface {
            height: 100%;
        }

        & gx-designer-tool-bar,
        & .gx-designer-tool-bar {
            position: absolute;
            z-index: 3;

            &.location-outside-top {
                bottom: 100%;
            }

            &.location-outside-right {
                left: 100%;
            }

            &.location-outside-bottom {
                top: 100%;
            }

            &.location-outside-left {
                right: 100%;
            }

            &.location-inside-sticky {
                position: sticky;
                top: 0px;
                max-width: min-content;
            }

            &.location-viewport-top {
                position: fixed;
                top: 5px;
                left: 50%;
                transform: translate(-50%, 0px);
            }
        }

        /* workaround to bug of chromium with position:sticky */
        & gx-designer-tool-bar {
            &.location-inside-sticky {
                position: absolute;
                top: var(--sticky-top);
                max-width: min-content;
            }
        }

        /* end of workaround */
        & gx-designer-tool-box {
            z-index: 1;
        }

        & gx-designer-tool-dimension {
            z-index: 2;
        }
    }
}

@keyframes gx-designer-view-highlight {
    0% {
        outline-width: 2px;
        outline-offset: -1px;
    }

    50% {
        outline-width: 6px;
        outline-offset: -3px;
    }

    100% {
        outline-width: 2px;
        outline-offset: -1px;
    }
}